/**
 * List Schema of ResponsavelConfigWhatsapp
 * @author Simpli CLI generator
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {ResponsavelConfigWhatsapp} from '@/model/resource/ResponsavelConfigWhatsapp'

/* TODO: review generated schema */
export class ListResponsavelConfigWhatsappSchema extends Schema {
  readonly name = 'ListResponsavelConfigWhatsapp'

  readonly fieldSet: FieldSet<ResponsavelConfigWhatsapp> = {
    mensagem: (): FieldComponent => ({
      is: Component.Render,
    }),
    templateId: (): FieldComponent => ({
      is: Component.Render,
    }),
    responsavel: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.responsavel?.$tag,
      },
    }),
    status: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.status?.$tag,
      },
    }),
    whatsappStatus: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.whatsappStatus?.$tag,
      },
    }),
    ocorrencia: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.ocorrencia?.$tag ?? '-',
      },
    }),
  }
}
